var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'core', 'view/transactions-report', 'app-common/view/base', 'app-common/component/loader', 'app-common/component/api-call', 'component/range-selector', 'template/report/landing.htm', 'template/report/zero-states/unmatched-receipts.htm', 'common/location'], function($, _, core, TransactionsReportView, BaseView, loader, apiCall, rangeSelector, landingViewTemplate, zerostateTemplate, location) {
  var UnmatchedReceiptsReportPage;
  return UnmatchedReceiptsReportPage = (function(_super) {

    __extends(UnmatchedReceiptsReportPage, _super);

    function UnmatchedReceiptsReportPage() {
      UnmatchedReceiptsReportPage.__super__.constructor.apply(this, arguments);
    }

    UnmatchedReceiptsReportPage.prototype.pageId = 'unmatched-receipts';

    UnmatchedReceiptsReportPage.prototype.reportType = 'unmatched-receipts';

    UnmatchedReceiptsReportPage.prototype.initialize = function(options, params) {
      var features;
      this.settingsModel = core.getModel('clientsettings');
      features = this.settingsModel.get('features') || [];
      if (!core.isCurrentClientBookkeeper() && (core.getEarliestUnmatchedReceiptTime() === null && features.zeroStatesReports)) {
        return BaseView.prototype.render.call(this, _.template(zerostateTemplate, {
          core: core
        }));
      } else {
        options = _.extend(options, {
          title: 'Unmatched Receipts',
          icon: 'ss-list ss-standard',
          features: ['date-range', 'view-all', 'search', 'edit'],
          template: landingViewTemplate,
          url: function(clientId, from, to, page) {
            var queryParams;
            queryParams = $.param({
              from: from,
              to: to,
              page: page,
              'results-per-page': 50
            });
            return "client/" + clientId + "/unmatched_receipts?" + queryParams;
          }
        });
        UnmatchedReceiptsReportPage.__super__.initialize.call(this, options, params);
        return this.loadData();
      }
    };

    UnmatchedReceiptsReportPage.prototype.initDateRangeFeatureData = function() {
      var _this = this;
      return rangeSelector.init(function() {
        return _this.trigger('report:date-change');
      }, {
        disable: ['CUSTOM']
      });
    };

    UnmatchedReceiptsReportPage.prototype.searchAction = function(searchKey) {
      return core.getRouter().loadPage('unmatched-receipts-search', null, {
        returnToPath: this.getType(),
        returnToName: 'Unmatched Receipts',
        queryVals: {
          searchkey: searchKey
        }
      }, 'Search: ' + searchKey);
    };

    UnmatchedReceiptsReportPage.prototype.getDownloadUrl = function() {
      var client, clientId, endDate, intervalAsDates, intervalType, queryParams, reportScale, startDate;
      client = core.getCurrentClient().toJSON();
      clientId = client.id;
      intervalType = rangeSelector.getIntervalType();
      reportScale = intervalType === 'YEAR' ? 'ANNUAL' : intervalType === 'QUARTER' ? 'QUARTERLY' : intervalType === 'MONTH' ? 'MONTHLY' : intervalType === 'ALL' ? 'ALL' : void 0;
      queryParams = intervalType !== 'ALL' ? (intervalAsDates = rangeSelector.getIntervalAsDates(), endDate = intervalAsDates.to.toString('yyyy-MM-dd'), startDate = intervalAsDates.from.toString('yyyy-MM-dd'), $.param({
        from: startDate,
        to: endDate,
        reportTimeScale: reportScale
      })) : $.param({
        reportTimeScale: reportScale
      });
      return location.apiRoot + core.getConfig().apiPrefix + ("document.json/client/" + clientId + "/unmatched_receipts/downloadAsXls?" + queryParams);
    };

    UnmatchedReceiptsReportPage.prototype.loadData = function(toPage) {
      var parameters, url,
        _this = this;
      parameters = this.getQueryParamsForTransactionsLoading(toPage);
      url = this.getTransactionsUrl(parameters);
      this.trigger('report:before-load-transactions', parameters.page);
      this.loadingPromise = apiCall('document', url, 'GET', null, 'json');
      loader.init();
      this.addUnavailableMessage(this.loadingPromise);
      return this.loadingPromise.done(function(data) {
        var transaction, _i, _len;
        if (!_this.UILoaded) {
          _this.initUI();
        }
        loader.hide();
        for (_i = 0, _len = data.length; _i < _len; _i++) {
          transaction = data[_i];
          _this.data.items.push(transaction);
        }
        return _this.trigger('report:after-load-transactions', data, parameters.page);
      });
    };

    return UnmatchedReceiptsReportPage;

  })(TransactionsReportView);
});
